exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addreport__wrap[data-v-680f8cf2]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;align-items:flex-start}.addreport__wrap label[data-v-680f8cf2]{margin:0 0 15px}.ckeditor[data-v-680f8cf2]{border:1px solid #e2e2e2;border-radius:8px}.addreport__button[data-v-680f8cf2],.l_title[data-v-680f8cf2]{margin-top:10px}.l_title[data-v-680f8cf2]{text-align:left;font-size:14px}", ""]);

// exports
